<script lang="ts">
	import { onMount } from 'svelte';

	let loaded = $state(true);

	onMount(() => {
		setTimeout(() => {
			loaded = false;
		}, 500);
	});
</script>

{#if loaded}
	<div
		class="fixed left-0 top-0 z-999999 flex h-screen w-screen items-center justify-center bg-white dark:bg-black"
	>
		<div
			class="h-16 w-16 animate-spin rounded-full border-4 border-solid border-brand-500 border-t-transparent"
		></div>
	</div>
{/if}
